import { Advice, AdviceDetail, TypeAdvice } from '@/types/advice';
import { createAppSlice } from '../createAppSlice';
import { MessageType } from '@/types/common';
import { Message } from '@/enums/message.enum';
import { MESSAGE } from '@/constants/message.constant';

type AdivceRecommendSliceState = {
  loading: boolean;
  listAgeRange: AgeRange[];
  listAdvice: Advice[];
  message?: MessageType;
};

const initialState: AdivceRecommendSliceState = {
  loading: false,
  listAgeRange: [],
  listAdvice: []
};

export const adviceRecommendSlice = createAppSlice({
  name: 'advice-recommend',
  initialState,
  reducers: (create) => ({
    getListAgeRange: create.asyncThunk(
      async (adviceCateCode?: string) => {
        const params = adviceCateCode && adviceCateCode !== 'SLEEP' && adviceCateCode !== 'EMOTION'
          ? { hasMore: true }
          : {};
        const response = await apiFetcher.get(
          'recommendation-advice/age-ranges',
          { params }
        );
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.listAgeRange = action.payload;
        },
        rejected: (state) => {
          state.loading = false;
        }
      }
    ),
    getListAdvice: create.asyncThunk(
      async (body: TypeAdvice) => {
        const response = await apiFetcher.post(
          `recommendation-advice/list`,
          body
        );
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.listAdvice = action.payload;
        },
        rejected: (state) => {
          state.loading = false;
          state.listAdvice = [];
          state.message = {
            type: Message.ERROR,
            message: MESSAGE.GET_LIST_ADVICE_FAIL
          };
        }
      }
    ),
    UpdateAdvice: create.asyncThunk(
      async (body: AdviceDetail) => {
        const response = await apiFetcher.put(
          `recommendation-advice/edit-advice/detail?id=${body.ID}`,
          {
            CONTENT: body.CONTENT,
            IMAGE: body.IMAGE,
            FILENAME: body.FILENAME
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.message = {
            type: Message.SUCCESS,
            message: MESSAGE.UPDATE_ADVICE_SUCCESS
          };
          state.listAdvice = state.listAdvice.map((advice) => ({
            ...advice,
            DETAILS: advice.DETAILS.map((detail) =>
              detail.ID === action.payload.ID ? action.payload : detail
            )
          }));
        },
        rejected: (state) => {
          state.loading = false;
          state.message = {
            type: Message.ERROR,
            message: MESSAGE.UPDATE_ADVICE_FAIL
          };
        }
      }
    )
  }),
  selectors: {
    watchListAge: (state) => state.listAgeRange,
    watchListAgeLoading: (state) => state.loading,
    watchListAdvice: (state) => state.listAdvice
  }
});

export const { watchListAge, watchListAgeLoading, watchListAdvice } =
  adviceRecommendSlice.selectors;

export const { getListAgeRange, getListAdvice, UpdateAdvice } =
  adviceRecommendSlice.actions;
